/* PlushyTales — slider avant/après (drag). Cible toute .pt-ba. */
(function () {
  function initBA(el) {
    if (el.dataset.ptBaInit) return;
    el.dataset.ptBaInit = '1';
    var dragging = false;
    function moveTo(clientX) {
      var r = el.getBoundingClientRect();
      var p = ((clientX - r.left) / r.width) * 100;
      p = Math.max(0, Math.min(100, p));
      el.style.setProperty('--pos', p + '%');
    }
    function down(e) { dragging = true; moveTo((e.touches ? e.touches[0] : e).clientX); if (e.cancelable) e.preventDefault(); }
    function move(e) { if (dragging) moveTo((e.touches ? e.touches[0] : e).clientX); }
    function up() { dragging = false; }
    el.addEventListener('mousedown', down);
    el.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
  }
  function initAll() { document.querySelectorAll('.pt-ba').forEach(initBA); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Shopify theme editor: re-init when a section is re-rendered
  document.addEventListener('shopify:section:load', initAll);
})();
